import { Row } from "antd";
import { quintanaRooUnidos } from "../src/assets/images";

const Closed = () => {
  return (
    // <div className="closed">
    // <h1>Sorry, we are closed</h1>
    // </div>
    <>
      <Row justify={"center"}>
        <img
          src={quintanaRooUnidos}
          style={{
            maxWidth: "75%",
          }}
        />
      </Row>
      <Row justify={"center"}>
        <h3>El periodo de inscripción ha concluido.</h3>
      </Row>
    </>
  );
};

export default Closed;
